module.exports = __webpack_public_path__ + "12JL32_YNt.png";


//////////////////
// WEBPACK FOOTER
// ./src/pubBiz/CommonCell/components/GoodItem/asset/grab.png
// module id = 1267
// module chunks = 418